// extracted by mini-css-extract-plugin
export default {"item-list":"FriedMobile_item-list__eldU1","item":"FriedMobile_item__NpEiL","section":"FriedMobile_section__he0Vs","category-title":"FriedMobile_category-title__rU3OC"};